import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const DefinitionTable = ({ title, termList, colHeader1 = "Term", colHeader2 = "Definition" }) => {
  const theme = useTheme();

  return (
    <TableContainer
      component={Paper}
      sx={{
        maxWidth: "100%",
        mx: "auto",
        my: 4,
        background: theme.palette.background.guideCard,
      }}
    >
      {title && (
        <Typography variant="h6" sx={{ p: 2 }}>
          {title}
        </Typography>
      )}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                fontWeight: "bold",
                color: theme.palette.secondary.main,
                width: "30%",
              }}
            >
              {colHeader1}
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                color: theme.palette.secondary.main,
              }}
            >
              {colHeader2}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {termList.map((row, i) => {
            const definitions = Array.isArray(row.definition)
              ? row.definition
              : [row.definition];

            return definitions.map((def, idx) => {
              const isLast = idx === definitions.length - 1;
              const borderStyle = isLast ? `1px solid ${theme.palette.divider}` : "none";

              return (
                <TableRow
                  key={`${row.term}-${idx}`}
                  sx={{
                    "&:hover": {
                      backgroundColor: theme.palette.action.hover,
                      cursor: "pointer",
                    },
                  }}
                >
                  <TableCell sx={{ borderBottom: borderStyle }}>
                    {idx === 0 ? row.term : ""}
                  </TableCell>
                  <TableCell sx={{ borderBottom: borderStyle }}>
                    {def}
                  </TableCell>
                </TableRow>
              );
            });
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DefinitionTable;
